export { SlugClassificationStrategy } from './strategy';
export type { SlugClassificationRule } from './rule';
